var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconLodgeFilled = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.995 12.872c0 .625-.521 1.115-1.111 1.115h-1.112l.025 5.563c0 .094-.007.187-.018.281v.56c0 .767-.621 1.388-1.389 1.388h-.555c-.039 0-.077 0-.115-.003-.049.003-.097.003-.146.003H16.612a1.389 1.389 0 0 1-1.389-1.389v-3.056a1.11 1.11 0 0 0-1.11-1.11H11.89a1.11 1.11 0 0 0-1.112 1.11v3.056c0 .768-.621 1.39-1.389 1.39H7.448c-.052 0-.104-.004-.156-.008a1.508 1.508 0 0 1-.125.007h-.556a1.389 1.389 0 0 1-1.389-1.389v-3.889c0-.031 0-.066.004-.097v-2.417H4.11A1.098 1.098 0 0 1 3 12.872c0-.312.104-.59.347-.833l8.904-7.761c.243-.243.52-.278.764-.278.243 0 .52.07.729.243l8.869 7.796c.278.243.416.52.382.833z",
    fill: "#1A202C",
    fillRule: "evenodd"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconLodgeFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-lodge-filled.beb2e9eb.svg";
export { ForwardRef as ReactComponent };